import type { WCIBMO_NAME } from '@/constants';
import { useOrderQuantityType } from '@/hooks/useOrderQuantityType';
import { pageViewTag } from '@/utils/metrics';

export const usePageViewWCIBMO = (type: WCIBMO_NAME) => {
  const quantityType = useOrderQuantityType();
  pageViewTag(`checkout/summary/${quantityType}/wcibmo/${type}`);
};
